import type {SignUpDto, SignupResp, SignUpResp} from "~/types/user";

export const useUser = () => {
  const baseUrl = '/users'
  const {fetch} = useAjax()

  const signUp = async (params: SignUpDto): Promise<boolean> => {
    try {
      await fetch<SignUpResp>(baseUrl + '/create', {
        method: "POST",
        body: params,
      })
      return true
    } catch (e: any) {
      Alert.error(e.message);
      return false;
    }
  }

  const generateTokenForPasswordReset = async (email: String): Promise<boolean> => {
    try {
      await fetch<SignupResp>(baseUrl + '/reset-password/generate-token', {
        method: "POST",
        body: {email},
      })
      return true
    } catch (e: any) {
      Alert.error(e.message);
      return false
    }
  }

  const validateTokenForPasswordReset = async (email: String, token: String, password: String) => {
    try {
      const resp = await fetch<SignupResp>(baseUrl + '/reset-password/validate-token', {
        method: "POST",
        body: {email, token, password},
      })
      return true
    } catch (e: any) {
      Alert.error(e.message);
      return false
    }
  }

  return {signUp, generateTokenForPasswordReset, validateTokenForPasswordReset}

}
